/**
 * BrainSwipe Feedback Page
 */

import { useSwipeStore } from '../stores/swipe';

export function BrainSwipeFeedback() {
  const {
    questions,
    currentIndex,
    lastAnswer,
    nextQuestion,
    endGame,
  } = useSwipeStore();
  
  const question = questions[currentIndex];
  
  if (!question || !lastAnswer) {
    return null;
  }
  
  const isCorrect = lastAnswer.correct;
  const correctOption = question.options[lastAnswer.correctIndex];
  
  return (
    <div className={`min-h-screen flex flex-col ${
      isCorrect 
        ? 'bg-gradient-to-b from-green-600 to-green-800'
        : 'bg-gradient-to-b from-red-600 to-red-800'
    }`}>
      
      <div className="flex-1 flex flex-col items-center justify-center p-4 text-white">
        
        <div className="text-7xl mb-3">
          {isCorrect ? '✅' : '❌'}
        </div>
        
        <h1 className="text-2xl font-bold mb-2">
          {isCorrect ? 'Правильно!' : 'Неправильно'}
        </h1>
        
        {isCorrect && (
          <div className="flex items-center gap-3 mb-4">
            <span className="text-2xl font-bold text-yellow-300">
              +{lastAnswer.pointsEarned} ⚡
            </span>
            {lastAnswer.multiplier > 1 && (
              <span className="bg-white/20 px-2 py-1 rounded-full text-sm">
                {lastAnswer.multiplier}x
              </span>
            )}
          </div>
        )}
        
        {lastAnswer.newMultiplierReached && (
          <div className="bg-yellow-500 text-black px-4 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
            🔥 Новый множитель: {lastAnswer.multiplier}x!
          </div>
        )}
        
        {lastAnswer.streakBroken && (
          <div className="text-white/70 text-sm mb-4">
            Серия прервана 😔
          </div>
        )}
        
        {lastAnswer.currentStreak > 0 && !lastAnswer.newMultiplierReached && (
          <div className="text-white/80 mb-4">
            🔥 Серия: {lastAnswer.currentStreak}
          </div>
        )}
        
        <div className={`w-full max-w-sm p-4 rounded-xl mb-4 ${
          isCorrect ? 'bg-white/20' : 'bg-green-500/30 border-2 border-green-400'
        }`}>
          <div className="text-xs text-white/70 mb-1">
            {isCorrect ? 'Твой ответ:' : 'Правильный ответ:'}
          </div>
          <div className="font-medium">{correctOption}</div>
        </div>
        
        {lastAnswer.explanation && (
          <div className="w-full max-w-sm bg-black/20 rounded-xl p-3 mb-4">
            <p className="text-sm text-white/90">{lastAnswer.explanation}</p>
          </div>
        )}
        
        <div className="flex gap-6 text-center text-sm text-white/70">
          <div>
            <div className="font-bold text-white">{lastAnswer.session.questionsAnswered}</div>
            <div>вопросов</div>
          </div>
          <div>
            <div className="font-bold text-white">{lastAnswer.session.accuracy}%</div>
            <div>точность</div>
          </div>
          <div>
            <div className="font-bold text-white">⚡{lastAnswer.session.totalPoints}</div>
            <div>очков</div>
          </div>
        </div>
      </div>
      
      {/* Кнопки: маленькая Завершить слева, большая Дальше справа */}
      <div className="p-4 pb-6">
        <div className="flex gap-3 max-w-sm mx-auto">
          <button
            onClick={endGame}
            className="flex-1 py-4 bg-white/20 rounded-xl text-white text-sm active:scale-95 transition-transform"
          >
            Стоп
          </button>
          <button
            onClick={nextQuestion}
            className="flex-[3] py-4 bg-white rounded-xl font-bold text-gray-900 text-lg active:scale-95 transition-transform"
          >
            Дальше →
          </button>
        </div>
      </div>
    </div>
  );
}
